<template>
    <div>
        <b-form @submit.prevent="submitProfile">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Заголовок *">
                        <b-form-input 
                            v-model="form.title" 
                            required 
                            placeholder="Введите заголовок новости"
                            maxlength="255"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="Краткое описание">
                        <b-form-textarea 
                            v-model="form.short_description" 
                            placeholder="Краткое описание новости" 
                            rows="3"
                            maxlength="500"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>

                                 <b-col cols="12">
                     <b-form-group label="Содержание *">
                         <div class="editor-container">
                             <!-- Переключатель режимов -->
                             <div class="editor-mode-switcher mb-2">
                                 <b-button-group size="sm">
                                     <b-button 
                                         :variant="editorMode === 'visual' ? 'primary' : 'outline-secondary'"
                                         @click="setEditorMode('visual')"
                                     >
                                         <i class="fas fa-eye"></i> Визуальный режим
                                     </b-button>
                                     <b-button 
                                         :variant="editorMode === 'html' ? 'primary' : 'outline-secondary'"
                                         @click="setEditorMode('html')"
                                     >
                                         <i class="fas fa-code"></i> HTML код
                                     </b-button>
                                 </b-button-group>
                             </div>
                             
                             <!-- Визуальный редактор -->
                             <VueEditor
                                 v-if="editorMode === 'visual'"
                                 v-model="form.content"
                                 class="news-editor"
                                 ref="editor"
                                 :editorToolbar="customToolbar"
                                 placeholder="Полное содержание новости..."
                             />
                             
                             <!-- HTML редактор -->
                             <div v-if="editorMode === 'html'" class="html-editor-container">
                                 <div class="html-editor-toolbar mb-2">
                                     <b-button 
                                         size="sm" 
                                         variant="outline-secondary"
                                         @click="formatHtml"
                                         title="Форматировать HTML код"
                                     >
                                         <i class="fas fa-code"></i> Форматировать
                                     </b-button>
                                 </div>
                                 <b-form-textarea
                                     v-model="form.content"
                                     class="html-editor"
                                     rows="15"
                                     placeholder="Введите HTML код..."
                                     @input="validateHtml"
                                 ></b-form-textarea>
                                 <div class="html-editor-info mt-2">
                                     <small class="text-muted">
                                         <i class="fas fa-info-circle"></i>
                                         Вы можете редактировать HTML код напрямую. Используйте теги: &lt;p&gt;, &lt;strong&gt;, &lt;em&gt;, &lt;ul&gt;, &lt;li&gt;, &lt;a&gt;, &lt;img&gt; и др.
                                     </small>
                                 </div>
                             </div>
                         </div>
                     </b-form-group>
                 </b-col>

                <b-col cols="12">
                    <b-form-group label="Изображение">
                        <b-form-file
                            v-model="form.image"
                            placeholder="Выберите изображение или перетащите файл сюда"
                            drop-placeholder="Перетащите файл сюда..."
                            accept="image/*"
                            :max-size="2 * 1024 * 1024"
                            @change="handleImageChange"
                        ></b-form-file>
                        <small class="form-text text-muted">
                            Поддерживаемые форматы: JPEG, PNG, JPG, GIF. Максимальный размер: 2MB
                        </small>
                        
                                                 <!-- Показываем текущее изображение при редактировании -->
                         <div v-if="news.image && !form.image && !form.remove_image" class="mt-2">
                             <img 
                                 :src="news.image_url" 
                                 alt="Текущее изображение" 
                                 class="img-thumbnail" 
                                 style="max-width: 200px; max-height: 200px;"
                             />
                             <div class="mt-1">
                                 <b-button 
                                     size="sm" 
                                     variant="outline-danger" 
                                     @click="removeImage"
                                 >
                                     Удалить изображение
                                 </b-button>
                             </div>
                         </div>
                         
                         <!-- Показываем сообщение если изображение удалено -->
                         <div v-if="form.remove_image" class="mt-2">
                             <b-alert variant="info" show>
                                 <i class="fas fa-info-circle"></i>
                                 Изображение будет удалено при сохранении
                                 <b-button 
                                     size="sm" 
                                     variant="outline-secondary" 
                                     class="ml-2"
                                     @click="cancelRemoveImage"
                                 >
                                     Отменить удаление
                                 </b-button>
                             </b-alert>
                         </div>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Категория *">
                        <b-form-select 
                            v-model="form.category" 
                            :options="categoryOptions" 
                            required
                        ></b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Статус *">
                        <b-form-select 
                            v-model="form.status" 
                            :options="statusOptions" 
                            required
                        ></b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Дата публикации">
                        <b-form-input 
                            v-model="form.published_at" 
                            type="datetime-local"
                            :disabled="form.status !== 'published'"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Запланированная дата">
                        <b-form-input 
                            v-model="form.scheduled_at" 
                            type="datetime-local"
                            :disabled="form.status !== 'scheduled'"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <!-- Показываем информацию о создателе только при редактировании -->
                <template v-if="news.id">
                    <b-col cols="12">
                        <b-form-group label="Автор">
                            <b-form-input 
                                :value="form.creator && form.creator.name ? form.creator.name : ''" 
                                readonly
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </template>

                <!-- Кнопки действий -->
                <b-col cols="12" class="mt-3">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button 
                                type="submit" 
                                variant="primary" 
                                :disabled="loading"
                            >
                                <b-spinner small v-if="loading"></b-spinner>
                                {{ news.id ? 'Сохранить изменения' : 'Создать новость' }}
                            </b-button>
                            
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="ml-2"
                                @click="$emit('closed')"
                                :disabled="loading"
                            >
                                Отмена
                            </b-button>
                        </div>

                        <!-- Дополнительные действия для опубликованных новостей -->
                        <div v-if="news.id && news.status === 'published'">
                            <b-button 
                                type="button" 
                                variant="warning" 
                                @click="archiveNews"
                                :disabled="loading"
                            >
                                Архивировать
                            </b-button>
                        </div>

                        <div v-if="news.id && news.status === 'draft'">
                            <b-button 
                                type="button" 
                                variant="success" 
                                @click="publishNews"
                                :disabled="loading"
                            >
                                Опубликовать
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form>

        <!-- Ошибки валидации -->
        <div v-if="validationErrors" class="mt-3">
            <b-alert variant="danger" show>
                <ul class="mb-0">
                    <li v-for="(error, field) in validationErrors" :key="field">
                        {{ error }}
                    </li>
                </ul>
            </b-alert>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { API_NEWS } from "@/constants";
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        props: {
            news: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                validationErrors: '',
                editorMode: 'visual', // Режим редактора: 'visual' или 'html'
                customToolbar: [
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ header: [1, 2, 3, false] }],
                    [{ color: [] }, { background: [] }],
                    ["link", "image"],
                    ["clean"]
                ],
                form: {
                    id: null,
                    title: '',
                    short_description: '',
                    content: '',
                    image: null,
                    published_at: null,
                    scheduled_at: null,
                    status: 'draft',
                    category: 'internal_employees',
                    creator_user_id: null,
                    creator: {}
                },
                statusOptions: [
                    { value: 'draft', text: 'Черновик' },
                    { value: 'published', text: 'Опубликовано' },
                    { value: 'scheduled', text: 'Запланировано' },
                    { value: 'archived', text: 'Архив' }
                ],
                categoryOptions: [
                    { value: 'internal_employees', text: 'Все внутренние сотрудники' },
                    { value: 'b2b', text: 'B2B' },
                    { value: 'b2c', text: 'B2C' },
                    { value: 'agents', text: 'Агенты' },
                    { value: 'clients', text: 'Клиенты' }
                ]
            }
        },
        computed: {
            ...mapGetters('auth', ['currentUser'])
        },
        watch: {
            news: {
                handler(newVal) {
                    this.initializeForm();
                },
                immediate: true
            },
            'form.status'(newStatus) {
                // Автоматически устанавливаем даты в зависимости от статуса
                if (newStatus === 'published' && !this.form.published_at) {
                    this.form.published_at = this.formatDateTimeLocal(new Date());
                } else if (newStatus === 'scheduled' && !this.form.scheduled_at) {
                    this.form.scheduled_at = this.formatDateTimeLocal(new Date());
                }
            }
        },
        methods: {
            initializeForm() {
                // Если это новая новость (нет ID), устанавливаем тестовые данные по умолчанию
                if (!this.news.id) {
                    this.form = {
                        id: null,
                        title: 'Онлайн встреча для всех агентов',
                        short_description: 'Всем привет! Встреча пройдет в онлайн формате в Яндекс Телемост! Ссылка внутри новости!',
                        content: '<p>Обязательно подключайтесь заранее! Всех ждем! Будет мастер-класс по продажам от наших лидеров.</p><p><br></p><p><strong>Ссылка:</strong> <a href="https://telemost.yandex.ru/" target="_blank">https://telemost.yandex.ru/</a></p>',
                        image: null,
                        published_at: this.formatDateTimeLocal(new Date()),
                        scheduled_at: null,
                        status: 'published',
                        category: 'agents',
                        creator_user_id: this.currentUser.id || null,
                        remove_image: false
                    };
                } else {
                    // Если это редактирование существующей новости
                    this.form = {
                        id: this.news.id,
                        title: this.news.title || '',
                        short_description: this.news.short_description || '',
                        content: this.news.content || '',
                        image: null,
                        published_at: this.parseDateFromBackend(this.news.published_at),
                        scheduled_at: this.parseDateFromBackend(this.news.scheduled_at),
                        status: this.news.status || 'draft',
                        category: this.news.category || 'internal_employees',
                        creator_user_id: this.news.creator_user_id || null,
                        remove_image: false
                    };
                    
                    // Сохраняем исходные данные изображения для возможности восстановления
                    this.originalImageData = {
                        image: this.news.image,
                        image_url: this.news.image_url
                    };
                }
                this.validationErrors = '';
            },

            formatDateTimeLocal(date) {
                if (!date || isNaN(date.getTime())) {
                    return null;
                }
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            },

            parseDateFromBackend(dateString) {
                if (!dateString) return null;
                
                // Если дата уже в формате d.m.Y H:i, конвертируем её
                if (typeof dateString === 'string' && dateString.match(/^\d{2}\.\d{2}\.\d{4}/)) {
                    const parts = dateString.split(' ');
                    const dateParts = parts[0].split('.');
                    const timeParts = parts[1] ? parts[1].split(':') : ['00', '00'];
                    
                    const day = dateParts[0];
                    const month = dateParts[1];
                    const year = dateParts[2];
                    const hours = timeParts[0];
                    const minutes = timeParts[1];
                    
                    return `${year}-${month}-${day}T${hours}:${minutes}`;
                }
                
                // Если это ISO дата, используем как есть
                if (typeof dateString === 'string' && dateString.includes('T')) {
                    return dateString;
                }
                
                // Иначе пытаемся распарсить как Date
                const date = new Date(dateString);
                if (!isNaN(date.getTime())) {
                    return this.formatDateTimeLocal(date);
                }
                
                return null;
            },

            handleImageChange(event) {
                const file = event.target.files[0];
                if (file) {
                    // Проверяем размер файла
                    if (file.size > 2 * 1024 * 1024) {
                        this.$bvToast.toast('Размер файла не должен превышать 2MB', {
                            title: 'Ошибка',
                            variant: 'danger',
                            solid: true
                        });
                        this.form.image = null;
                        return;
                    }
                }
            },

            removeImage() {
                this.form.image = null;
                // Добавляем флаг для удаления изображения
                this.form.remove_image = true;
                // Очищаем изображение в объекте news для обновления UI
                this.$set(this.news, 'image', null);
                this.$set(this.news, 'image_url', null);
            },

            cancelRemoveImage() {
                this.form.remove_image = false;
                // Восстанавливаем изображение из исходных данных
                if (this.originalImageData) {
                    this.$set(this.news, 'image', this.originalImageData.image);
                    this.$set(this.news, 'image_url', this.originalImageData.image_url);
                }
            },

            async submitProfile() {
                console.log('submitProfile вызван');
                console.log('Форма перед отправкой:', this.form);
                this.loading = true;
                this.validationErrors = '';

                try {
                    const formData = new FormData();
                    
                    // Обязательные поля - всегда отправляем
                    formData.append('title', this.form.title || '');
                    formData.append('content', this.form.content || '');
                    formData.append('status', this.form.status || 'draft');
                    formData.append('category', this.form.category || 'internal_employees');
                    
                    // Опциональные поля
                    if (this.form.short_description) {
                        formData.append('short_description', this.form.short_description);
                    }
                    
                    if (this.form.creator_user_id) {
                        formData.append('creator_user_id', this.form.creator_user_id);
                    }
                    
                    if (this.form.published_at) {
                        formData.append('published_at', this.form.published_at);
                    }
                    
                    if (this.form.scheduled_at) {
                        formData.append('scheduled_at', this.form.scheduled_at);
                    }
                    
                    // ID для обновления
                    if (this.form.id) {
                        formData.append('id', this.form.id);
                    }
                    
                    // Обрабатываем изображение
                    if (this.form.image instanceof File) {
                        formData.append('image', this.form.image);
                    }
                    
                    // Обрабатываем удаление изображения
                    if (this.form.remove_image) {
                        formData.append('remove_image', '1');
                    }

                    console.log('FormData создан:', Object.fromEntries(formData));

                    let response;
                    if (this.form.id) {
                        // Обновление
                        console.log('Обновление новости:', this.form.id);
                        formData.append('_method', 'PUT'); // Добавляем метод для Laravel
                        response = await api.call('post', `${API_NEWS}/${this.form.id}`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                    } else {
                        // Создание
                        console.log('Создание новой новости');
                        response = await api.call('post', `${API_NEWS}`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                    }

                    console.log('Ответ от сервера:', response);
                    this.$emit('updated', response.data);
                    this.makeToast('success', this.form.id ? 'Новость успешно обновлена' : 'Новость успешно создана');

                } catch (error) {
                    console.error('Ошибка в submitProfile:', error);
                    console.error('Детали ошибки:', error.response);
                    
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.validationErrors = error.response.data.errors;
                    } else {
                        this.makeToast('danger', 'Произошла ошибка при сохранении новости');
                    }
                } finally {
                    this.loading = false;
                }
            },

            async publishNews() {
                if (!this.form.id) {
                    this.$bvToast.toast('Сначала сохраните новость', {
                        title: 'Предупреждение',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }

                this.loading = true;
                try {
                    const response = await api.call('post', `${API_NEWS}/${this.form.id}/publish`);
                    this.$emit('updated', response.data.data);
                    
                    this.$bvToast.toast('Новость успешно опубликована', {
                        title: 'Успех',
                        variant: 'success',
                        solid: true
                    });
                } catch (error) {
                    this.$bvToast.toast('Ошибка при публикации новости', {
                        title: 'Ошибка',
                        variant: 'danger',
                        solid: true
                    });
                } finally {
                    this.loading = false;
                }
            },

            async archiveNews() {
                if (!this.form.id) return;

                this.loading = true;
                try {
                    const response = await api.call('post', `${API_NEWS}/${this.form.id}/archive`);
                    this.$emit('updated', response.data.data);
                    
                    this.$bvToast.toast('Новость успешно архивирована', {
                        title: 'Успех',
                        variant: 'success',
                        solid: true
                    });
                } catch (error) {
                    this.$bvToast.toast('Ошибка при архивировании новости', {
                        title: 'Ошибка',
                        variant: 'danger',
                        solid: true
                    });
                } finally {
                    this.loading = false;
                }
            },
            
            makeToast(variant, message) {
                this.$bvToast.toast(message, {
                    title: variant === 'success' ? 'Успешно' : 'Ошибка',
                    variant: variant,
                    solid: true
                });
            },

            /**
             * Переключение режима редактора
             */
            setEditorMode(mode) {
                this.editorMode = mode;
                
                // Если переключаемся в визуальный режим, обновляем редактор
                if (mode === 'visual' && this.$refs.editor) {
                    this.$nextTick(() => {
                        this.$refs.editor.quill.setContents(this.$refs.editor.quill.clipboard.convert(this.form.content));
                    });
                }
            },

            /**
             * Валидация HTML кода
             */
            validateHtml() {
                // Простая валидация - можно расширить
                const html = this.form.content;
                
                // Проверяем на наличие потенциально опасных тегов
                const dangerousTags = ['script', 'iframe', 'object', 'embed'];
                const hasDangerousTags = dangerousTags.some(tag => 
                    html.toLowerCase().includes(`<${tag}`)
                );
                
                if (hasDangerousTags) {
                    this.makeToast('warning', 'Обнаружены потенциально опасные HTML теги. Рекомендуется их удалить.');
                }
            },

            /**
             * Форматирование HTML кода
             */
            formatHtml() {
                if (this.editorMode === 'html') {
                    // Простое форматирование - можно использовать более продвинутые библиотеки
                    let html = this.form.content;
                    
                    // Добавляем отступы для лучшей читаемости
                    html = html.replace(/></g, '>\n<');
                    html = html.replace(/\n\s*\n/g, '\n');
                    
                    this.form.content = html;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.news-editor {
    .ql-editor {
        min-height: 200px;
        max-height: 400px;
        height: 200px;
        font-size: 14px;
        line-height: 1.6;
    }
    
    .ql-toolbar {
        height: 46px;
        overflow-x: inherit;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-bottom: none;
    }
    
    .ql-container {
        border: 1px solid #ccc;
        border-top: none;
    }
}

.ql-formats {
    margin-bottom: 0 !important;
}

.editor-container {
    .editor-mode-switcher {
        border-bottom: 1px solid #e9ecef;
        padding-bottom: 10px;
    }
}

.html-editor-container {
    .html-editor-toolbar {
        display: flex;
        gap: 10px;
        align-items: center;
    }
    
    .html-editor {
        font-family: 'Courier New', monospace;
        font-size: 13px;
        line-height: 1.4;
        background-color: #f8f9fa;
        border: 1px solid #ced4da;
        border-radius: 4px;
        
        &:focus {
            background-color: #fff;
            border-color: #80bdff;
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }
    }
    
    .html-editor-info {
        background-color: #e7f3ff;
        border: 1px solid #b3d9ff;
        border-radius: 4px;
        padding: 8px 12px;
        
        small {
            color: #0056b3 !important;
        }
    }
}
</style>
